import React,{Component} from "react";
import Tab from "@material-ui/core/Tab";
import { Tabs,Box } from "@material-ui/core";
import LeaveManager from "./AdminLeaveManager";
import AdminLE from "./AdminLE";
import AdminLeaveCancel from "./AdminLeaveCancel";
import AdminLeavesDetail from "./AdminLeavesDetail";
//import Leavedetail_all from "./Leavedetail_all_2";
import Cookies from "universal-cookie";
import AdminLeavedetail_all from "./AdminLeavedetail_all";

const cookies = new Cookies();

const axios = require("axios");
const ref = React.createRef();
class AdminLeaveManagementWAH extends Component{
    constructor(props)
    {
        super(props);
           this.state={value:0,tab1:"block",tab2:"none",tab3:"none",tab4:"none",tab5:"none",path:cookies.get("phpclass").substring(0,cookies.get("phpclass").length-3)};

//           this.state={value:0,tab1:"block",tab2:"none",tab3:"none",tab4:"none",path:cookies.get("phpclass").substring(0,cookies.get("phpclass").length-3)};
    }
    
    render(){
        return(
            <div className="containera1">
                <p style={{float:"right", width:"100px"}}>WAHCANTT</p>

                    <Box position="static"  >

                        <Tabs
                            value={this.state.value}
                            textColor="inherit"
                            indicatorColor="secondary"
                            style={{marginLeft:"50px"}}
                            
                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none",tab3:"none",tab4:"none",tab5:"none"}); else if(newValue == 1) this.setState({value:newValue,tab1:"none",tab2:"block",tab3:"none",tab4:"none",tab5:"none" }); else if(newValue == 2) this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"block",tab4:"none",tab5:"none"}); else if(newValue == 3) this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"none",tab4:"block",tab5:"none"}); else this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"none",tab4:"none",tab5:"block"}) ;

//                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none",tab3:"none",tab4:"none"}); else if(newValue == 1) this.setState({value:newValue,tab1:"none",tab2:"block",tab3:"none",tab4:"none" }); else if(newValue == 2) this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"block",tab4:"none"}); else this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"none",tab4:"block"}) ;                                                             
                            }}
                            >
                            <Tab label="Leave detail / balance" > </Tab> 
                            <Tab label="Leave encashment"></Tab>
                            <Tab label="Leave Cancellation"></Tab>
                            <Tab label="Leave Detail Report"></Tab>
                            <Tab label="Leave Detail All"></Tab>

                        </Tabs>
                    </Box>
                    <div  style={{display:this.state.tab1,marginLeft:"10%"}}>
                            <LeaveManager apipath={this.state.path+"WAHAPI"}/>
                    </div>


                    <div  style={{display:this.state.tab2,marginLeft:"10%"}}>
                        <AdminLE apipath={this.state.path+"WAHAPI"}/>
                    </div>
                    <div  style={{display:this.state.tab3,marginLeft:"10%"}}>
                        <AdminLeaveCancel apipath={this.state.path+"WAHAPI"}/>
                    </div>
                    <div  style={{display:this.state.tab4,marginLeft:"10%"}}>
                        <AdminLeavesDetail apipath={this.state.path+"WAHAPI"}/>
                    </div>
                    <div  style={{display:this.state.tab5,marginLeft:"10%"}}>
                        <AdminLeavedetail_all apipath={this.state.path+"WAHAPI"}/>
                    </div>
                    <br></br><br></br>
                </div>
/*}            </div>*/
    )}
}
export default AdminLeaveManagementWAH;